export default "__VITE_ASSET__SXxugEbS__"